// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"afea0759","453":"3bdd8ed8","455":"180e7b01"}[chunkId] + ".chunk.js";
};